import { useEffect } from "react";
import { Card, Tabs } from "antd";
import { t } from "i18next";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import AppConfig from "../../core/service/AppConfig";
import BrandingPanel from "./BrandingPanel";
import WhatsAppSettingsPanel from "./WhatsAppSettingsPanel";

/** Marka ayarları (logo, başlık vb.) + WhatsApp destek butonu. Yetki: BRANDING_MANAGE. */
export default function BrandingSettingsPage()
{
    useEffect(() => {
        document.title = `${t("Branding")} | ${AppConfig.getRisTitle()}`;
    }, []);

    return (
        <LayoutWithSider sidebarTitle={t("Branding")} fullWidth>
            <Card title={t("Branding")} className="settings-card">
                <Tabs
                    defaultActiveKey="branding"
                    items={[
                        { key: "branding", label: t("Branding"), children: <BrandingPanel /> },
                        { key: "whatsapp", label: "WhatsApp", children: <WhatsAppSettingsPanel /> },
                    ]}
                />
            </Card>
        </LayoutWithSider>
    );
}
